import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEpisodes } from '@contexts/EpisodesContext';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';
import { getRecentEpisodes } from '@models/episodes/episodeModel';
import { ROUTES } from '@constants/routes';
import { useGlobalSearchController } from './useGlobalSearchController';

export function useHomePageController() {
  const navigate = useNavigate();
  const { episodes, feedMetadata, loading, error } = useEpisodes();
  const { toggleEpisodePlayback } = useAudioPlayer();
  const [showSearchResults, setShowSearchResults] = useState(false);
  const globalSearch = useGlobalSearchController(setShowSearchResults);
  const recentEpisodes = getRecentEpisodes(episodes);

  const handlePlayClick = useCallback((episode) => {
    toggleEpisodePlayback(episode);
  }, [toggleEpisodePlayback]);

  const goToAllEpisodes = useCallback(
    () => navigate(ROUTES.ALL_EPISODES),
    [navigate]
  );

  return {
    episodes,
    recentEpisodes,
    feedMetadata,
    loading,
    error,
    showSearchResults,
    globalSearch,
    hasMoreEpisodes: recentEpisodes.length < episodes.length,
    onPlayClick: handlePlayClick,
    onViewAll: goToAllEpisodes
  };
}
